import React, { useEffect } from 'react';
import { Card, Container, Spinner } from 'react-bootstrap';
import { FaSignOutAlt } from 'react-icons/fa';
import { logout } from 'actions';
import '../Login/Login.css';
import './Logout.css';

const Logout = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      logout();
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="login-background">
      <div className="login-overlay" />
      <Container fluid className="login-container logout-container px-2 px-sm-3">
        <Card className="glass-card login-card logout-card">
          <Card.Body className="login-form-body">
            <div className="login-header">
              <img
                src="/images/motomco_logo_reduzida_branca.png"
                alt="Motomco"
                className="login-brand-logo"
              />
              <h1 className="login-brand">Motomco</h1>
              <p className="login-subtitle logout-message">
                Sua sessão está sendo encerrada com segurança. Aguarde um momento.
              </p>
            </div>

            <div className="logout-content text-center">
              <div className="logout-status">
                <FaSignOutAlt className="logout-icon" aria-hidden="true" />
                <p className="logout-title">Saindo...</p>
              </div>
              <div className="logout-spinner-wrap">
                <Spinner animation="border" role="status" aria-label="Encerrando sessão" />
              </div>
            </div>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

export default Logout;
